import styles from './Faq.module.scss'
import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'
import FaqInner from '../FaqInner'

interface FaqDetail {
  title: string
  text: string | JSX.Element
}

export interface FaqItem {
  sectionTitle: string
  sectionRead: string
  faq: FaqDetail[]
}

interface Props {
  FaqEach: FaqItem[]
}

const Faq: React.FC<Props> = ({ FaqEach }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.faq} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      {FaqEach.map((item, index) => (
        <div key={index}>
          <h2 className={styles.sectionTitle}>{item.sectionTitle}</h2>
          <p className={styles.sectionRead}>{item.sectionRead}</p>
          <div className={styles.faqContainer}>
            <FaqInner faq={item.faq} />
          </div>
        </div>
      ))}
    </section>
  )
}

export default Faq
